import { JsonDataItem } from 'types';
import { baseQuery } from '../baseQuery';

export const postRemoveTaskLock = async ({ taskId }: JsonDataItem) => {
  const data = await baseQuery('task/removesoftlock', {
    type: 'DELETE',
    body: {
      task_ID: taskId,
    },
  });

  return data;
};
